import React from 'react';
import { AccessibilityAlertProps } from '.';
import styles from './accessibility-alert.scss';

export const AccessibilityAlert = ({ message }: AccessibilityAlertProps) => (
  <div id="srmessage" role="alert" className={styles.alert}>
    {message}
  </div>
);
